// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1H0bn"};